// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type SearchOverviewTableQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  searchOverviewFilter: PrivateSchemaTypes.AnalyticsSearchFilter;
}>;


export type SearchOverviewTableQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { search: (
      { __typename?: 'AnalyticsSearchModel' }
      & Pick<PrivateSchemaTypes.AnalyticsSearchModel, 'searchOverviewCount'>
      & { searchOverview: Array<(
        { __typename?: 'AnalyticsSearchOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsSearchOverviewModel, 'search_term' | 'count' | 'avg_results' | 'last_searched'>
      )> }
    ) }
  ) }
);

export type SearchAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  filter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  chartTimeUnit: PrivateSchemaTypes.TimeUnitEnum;
}>;


export type SearchAnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { search: (
      { __typename?: 'AnalyticsSearchModel' }
      & Pick<PrivateSchemaTypes.AnalyticsSearchModel, 'searchesCount' | 'uniqueUsersWhoUsedSearchCount'>
      & { searchesWithNoResultsCount: PrivateSchemaTypes.AnalyticsSearchModel['searchesCount'] }
      & { searchByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
      )>, searchNoResultsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
      )> }
    ) }
  ) }
);


export const SearchOverviewTableDocument = gql`
    query SearchOverviewTable($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $searchOverviewFilter: AnalyticsSearchFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    search {
      searchOverview(overviewTableFilter: $searchOverviewFilter) {
        search_term
        count
        avg_results
        last_searched
      }
      searchOverviewCount(overviewTableFilter: $searchOverviewFilter)
    }
  }
}
    `;

/**
 * __useSearchOverviewTableQuery__
 *
 * To run a query within a React component, call `useSearchOverviewTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOverviewTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOverviewTableQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      searchOverviewFilter: // value for 'searchOverviewFilter'
 *   },
 * });
 */
export function useSearchOverviewTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchOverviewTableQuery, SearchOverviewTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchOverviewTableQuery, SearchOverviewTableQueryVariables>(SearchOverviewTableDocument, options);
      }
export function useSearchOverviewTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchOverviewTableQuery, SearchOverviewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchOverviewTableQuery, SearchOverviewTableQueryVariables>(SearchOverviewTableDocument, options);
        }
export type SearchOverviewTableQueryHookResult = ReturnType<typeof useSearchOverviewTableQuery>;
export type SearchOverviewTableLazyQueryHookResult = ReturnType<typeof useSearchOverviewTableLazyQuery>;
export type SearchOverviewTableQueryResult = Apollo.QueryResult<SearchOverviewTableQuery, SearchOverviewTableQueryVariables>;
export const SearchAnalyticsDocument = gql`
    query SearchAnalytics($filter: AnalyticsFilterWithGroups!, $chartTimeUnit: TimeUnitEnum!) {
  analytics(filter: $filter) {
    search {
      searchesWithNoResultsCount: searchesCount(filters: {name: "noResults"})
      searchesCount
      uniqueUsersWhoUsedSearchCount
      searchByTimeUnit(unit: $chartTimeUnit) {
        count
        day
      }
      searchNoResultsByTimeUnit(unit: $chartTimeUnit, resultSelect: NO_RESULT) {
        count
        day
      }
    }
  }
}
    `;

/**
 * __useSearchAnalyticsQuery__
 *
 * To run a query within a React component, call `useSearchAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAnalyticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      chartTimeUnit: // value for 'chartTimeUnit'
 *   },
 * });
 */
export function useSearchAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAnalyticsQuery, SearchAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAnalyticsQuery, SearchAnalyticsQueryVariables>(SearchAnalyticsDocument, options);
      }
export function useSearchAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAnalyticsQuery, SearchAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAnalyticsQuery, SearchAnalyticsQueryVariables>(SearchAnalyticsDocument, options);
        }
export type SearchAnalyticsQueryHookResult = ReturnType<typeof useSearchAnalyticsQuery>;
export type SearchAnalyticsLazyQueryHookResult = ReturnType<typeof useSearchAnalyticsLazyQuery>;
export type SearchAnalyticsQueryResult = Apollo.QueryResult<SearchAnalyticsQuery, SearchAnalyticsQueryVariables>;